var map = {
	"./anatoly_p.png": 6368,
	"./dmitro_z.png": 6279,
	"./igor_m.png": 2605,
	"./mikhaylo_k.png": 8492,
	"./mykola_p.png": 1489,
	"./mykola_z.png": 9496,
	"./oleksandr_ya.png": 7040,
	"./petro_m.png": 2808,
	"./sergii_n.png": 4716,
	"./sergii_sh.png": 1493,
	"./vadim_p.png": 2621,
	"./valerii_p.png": 3892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2387;